// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[id='baseSearchBox']::placeholder{color:#28282E !important;opacity:1 !important}
`, "",{"version":3,"sources":["webpack://./src/js/apps/components/common/CustomSelect/styles.scss"],"names":[],"mappings":"AAAA,uCACI,wBAAyB,CACzB,oBAAqB","sourcesContent":["input[id='baseSearchBox']::placeholder {\n    color: #28282E !important;\n    opacity: 1 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
